import {useEffect} from "react";
import {useRouter} from "next/router";
import shopApi from "../../api/shop";
import store from "../../store";
import allActions from "../../services/actionsArray";
import SiteCustomPage from "../../components/site/SiteCustomPage";
import {IPageProps} from "../../types/pages";
import {GetServerSideProps} from "next";
import {MetaWrapper} from "../../components/MetaWrapper";
import {getSeparateDomain} from "../../services/utils";
import generalAction from "../../api/generalAction";
import {domainUrl} from "../../helper";

export default function Page(props: IPageProps) {
    const {locale, dbName, dispatches, metas, content, domain} = props;
    const {query, ...router} = useRouter();
    const {dispatch} = store;
    const {
        yoast: [{
            yoast_facebook_description: FB_desc = null,
            yoast_facebook_title: FB_title = null,
            yoast_twitter_description: TW_desc = null,
            yoast_twitter_title: TW_title = null,
            yoast_focus_keyword: y_keyword = null
        } = {}] = [],
        data: [{
            meta_title: m_title = content.data[0].page_title,
            meta_description: m_desc = "",
            meta_keywords: m_keyword = "",
            image: m_img = ""
        } = {}] = []
    } = content || {}

    useEffect(() => {
        window.history.replaceState(null, "", window.location.pathname);
    }, [query.pageSlug, locale]);

    useEffect(() => {
        window.onpopstate = async () => {
            await router.push(window.location.pathname)
        }
    }, [query.pageSlug, locale, router.route, router])

    useEffect(() => {
        for (let actionKey in dispatches) {
            // @ts-ignore
            dispatch(allActions[actionKey](dispatches[actionKey]));
        }
    }, [locale]);

    return (
        <MetaWrapper
            title={!!m_title ? m_title : content.data[0].page_title}
            m_desc={m_desc}
            m_url={domainUrl(dbName + "/" + locale + router.asPath)}
            m_img={!!m_img ? `${domain}/${m_img}` : undefined}
            m_key={m_keyword}
            TW_desc={TW_desc}
            FB_desc={FB_desc}
            TW_title={TW_title}
            FB_title={FB_title}
            y_keyword={y_keyword}
            locale={locale}
            domain={domain}
            dbName={dbName}
        >
            <SiteCustomPage
                pageSlug={query.pageSlug}
                {...props}
            />
        </MetaWrapper>
    )
}

export const getServerSideProps: GetServerSideProps = async ({locale, req, res, query}: any) => {
    let selectedCurrency: string = '';
    let selectedRate;
    const dbName = req.headers["x-forwarded-host"];
    const domain = getSeparateDomain(dbName)
    res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=59");

    const generalOptions = {
        locale,
        selectedCurrency,
        dbName
    }

    const {
        locale: defaultLocaleSelected,
        rate,
        currency,
        dispatches
    } = await generalAction.action("general", generalOptions, req.m)

    /**** GETTING RATE FOR CURRENCY ****/
    if (Object.keys(req.query).length > 0) {
        selectedRate = rate.currencies_new?.find((item: any) => item.code == selectedCurrency);
    }
    let selectedLocale = locale != "catchAll" ? locale : defaultLocaleSelected;
    const {pageSlug, page = 1} = query;


    let redirect = false;
    let dataContent = [];

    const pagesOption = {
        locale: selectedLocale,
        pageSlug: pageSlug,
        dbName
    }

    dataContent = await shopApi.getAsyncPagesBySlug(pagesOption, req.m)
    const metaTags = await shopApi.getHomeMetaAsync(domain, selectedLocale, req.m);
    const getBuilderData = await shopApi.getBuilderDataAsync(dataContent.data?.[0].cms_page_id, domain, selectedLocale, req.m)

    const generalDispatches = {
        ...dispatches.clientSide,
        ...dispatches.serverSide,
    };
    if (dataContent?.notFound) {
        return {
            notFound: true
        }
    }
    const getLocales = await shopApi.getLocale(selectedLocale, req.m)
    const coreConfigs = await shopApi.getCoreConf(selectedLocale, req.m);
    let arrFooterTrack = [];
    let showSubFooter = "none";
    let isBlogActive = false;
    if (coreConfigs.sales_tracking_tracking_active?.value === "1" || !coreConfigs.hasOwnProperty("sales_tracking_tracking_active")) {
        arrFooterTrack.push({href: "/tracking", id: "tracking", defaultMessage: "Tracking Number"})
    }
    if (coreConfigs.theme_contact_us_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_contact_us_active")) {
        arrFooterTrack.push({href: "/contact", id: "contact_with_us", defaultMessage: "Contact With Us"})
    }
    if (coreConfigs.theme_subscription_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_subscription_active")) {
        showSubFooter = "block";
    }
    if (coreConfigs.theme_blog_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_blog_active")) {
        isBlogActive = true;
    }

    const footerContent = coreConfigs.general_content_footer_footer_content?.find((item: any) => item?.locale_code === selectedLocale);

    const { general_content_custom_scripts_custom_javascript, general_content_custom_scripts_custom_css } = coreConfigs || {};
    const { value: customScriptAnalyze } = general_content_custom_scripts_custom_javascript || {};
    const { value: customCssAnalyze } = general_content_custom_scripts_custom_css || {};

    return {
        props: {
            locale: selectedLocale,
            dispatches: generalDispatches,
            redirect,
            getBuilderData: getBuilderData[0] || {},
            dbName,
            domain,
            content: dataContent,
            metas: metaTags,
            currency,
            rate: selectedRate?.exchange_rate?.rate || 1,
            topBarLocales: getLocales[0].locales,
            hasTracking: arrFooterTrack,
            footerContent: footerContent ?? null,
            showSubscription: showSubFooter ?? null,
            isBlogActive: isBlogActive,
            customScriptAnalyze: customScriptAnalyze ?? null,
            customCssAnalyze: customCssAnalyze ?? null
        },
    };
}

